(function () {
  var nav = document.querySelector('[data-header-navigation]');
  if (!nav) return;

  var entries = Array.prototype.slice.call(
    nav.querySelectorAll('.header-navigation__entry--has-menu')
  );

  function close(entry) {
    // An open entry moved into "More" closes with it
    Array.prototype.forEach.call(
      entry.querySelectorAll('.header-navigation__entry.is-open'),
      close
    );
    entry.classList.remove('is-open');
    var toggle = entry.querySelector('[data-nav-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    var panel = entry.querySelector('.header-navigation__panel');
    if (panel) panel.classList.remove('is-child-open');
  }

  function closeAll() {
    entries.forEach(close);
  }

  // Hug panels are pinned to their entry's left edge and grow rightward, so a
  // wide one overflows the navbar's right edge. When that happens, slide it left
  // just enough to sit flush with the navbar's right edge (clamped so it never
  // runs past the navbar's left edge). Only the hug variant needs this — the
  // full variant is already edge-anchored in CSS.
  function positionHugPanel(entry) {
    var panel = entry.querySelector('.header-navigation__panel--hug');
    if (!panel) return;
    panel.style.left = ''; // reset before measuring
    if (isMobile()) return;
    // "More" is right-anchored in CSS; entries inside it open as side flyouts
    if (entry.hasAttribute('data-nav-more') || entry.closest('[data-nav-more-list]')) return;
    var list = nav.querySelector('.header-navigation__list');
    if (!list) return;
    var navRect = list.getBoundingClientRect();
    var entryLeft = entry.getBoundingClientRect().left;
    var panelRight = panel.getBoundingClientRect().right;
    var overflow = panelRight - navRect.right;
    if (overflow <= 0) return;
    // Don't pull the left edge past the navbar's left edge.
    var shift = Math.min(overflow, entryLeft - navRect.left);
    if (shift > 0) panel.style.left = -Math.round(shift) + 'px';
  }

  function open(entry) {
    // Layout may have shifted since load ("More" overflow, search row, fonts)
    if (typeof setFullPanelBounds === 'function') setFullPanelBounds();
    // Keep ancestors open: an entry inside "More" opens while More stays open
    entries.forEach(function (other) {
      if (other !== entry && !other.contains(entry)) close(other);
    });
    entry.classList.add('is-open');
    var toggle = entry.querySelector('[data-nav-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    positionHugPanel(entry);
  }

  var isMobile = function () {
    return window.matchMedia('(max-width: 989px)').matches;
  };

  // An open entry in the same list as this one (a sibling tab, or a sibling
  // flyout inside "More") — null when none is open
  function openSibling(entry) {
    var list = entry.parentElement;
    if (!list) return null;
    for (var i = 0; i < list.children.length; i++) {
      var el = list.children[i];
      if (el !== entry && el.classList.contains('is-open')) return el;
    }
    return null;
  }

  var HOVER_SWITCH_DELAY = 100;

  entries.forEach(function (entry) {
    var toggle = entry.querySelector('[data-nav-toggle]');
    if (!toggle) return;
    var hoverTimer = null;

    function cancelHoverSwitch() {
      clearTimeout(hoverTimer);
      hoverTimer = null;
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      cancelHoverSwitch();
      if (entry.classList.contains('is-open')) {
        close(entry);
      } else {
        open(entry);
      }
    });

    // Desktop hover-to-switch: the first menu opens on click; once one is open,
    // resting on a sibling tab opens that one instead (and closes the current).
    // The short delay keeps a cursor crossing the row from flickering menus.
    toggle.addEventListener('mouseenter', function () {
      if (isMobile() || entry.classList.contains('is-open') || !openSibling(entry)) return;
      cancelHoverSwitch();
      hoverTimer = setTimeout(function () {
        hoverTimer = null;
        if (isMobile() || entry.classList.contains('is-open') || !openSibling(entry)) return;
        open(entry);
      }, HOVER_SWITCH_DELAY);
    });
    toggle.addEventListener('mouseleave', cancelHoverSwitch);
  });

  // Master-detail: desktop = hover shows children in the right column;
  // mobile = tapping a master item drills into its children (push navigation).
  entries.forEach(function (entry) {
    var panel = entry.querySelector('.header-navigation__panel');
    var main = entry.querySelector('.header-navigation__main');
    var detail = entry.querySelector('.header-navigation__detail');
    if (!main || !detail) return;

    var items = Array.prototype.slice.call(
      main.querySelectorAll('.header-navigation__item[data-detail-index]')
    );
    var panes = Array.prototype.slice.call(
      detail.querySelectorAll('[data-detail-pane]')
    );

    function activate(idx) {
      items.forEach(function (it) {
        it.classList.toggle('is-active', it.getAttribute('data-detail-index') === String(idx));
      });
      panes.forEach(function (p) {
        p.hidden = p.getAttribute('data-detail-pane') !== String(idx);
      });
    }

    items.forEach(function (it) {
      it.addEventListener('mouseenter', function () {
        if (!isMobile()) activate(it.getAttribute('data-detail-index'));
      });
      it.addEventListener('click', function (e) {
        if (!isMobile()) return;
        var idx = it.getAttribute('data-detail-index');
        var pane = detail.querySelector('[data-detail-pane="' + idx + '"]');
        // Only drill when there are children; otherwise let the link navigate
        if (pane && pane.querySelector('.header-navigation__children')) {
          e.preventDefault();
          activate(idx);
          if (panel) panel.classList.add('is-child-open');
        }
      });
    });

    activate('0'); // default first item's children (desktop right column)
  });

  // Child back bar — return from children to the menu's item list
  Array.prototype.forEach.call(
    document.querySelectorAll('[data-nav-child-back]'),
    function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var panel = el.closest('.header-navigation__panel');
        if (panel) panel.classList.remove('is-child-open');
      });
    }
  );

  // Close on outside click (desktop dropdowns)
  document.addEventListener('click', function (e) {
    if (!nav.contains(e.target)) closeAll();
  });

  // ---- Desktop overflow: "More" dropdown ----
  // Entries that don't fit on one row move (in order) into the More panel; on
  // every resize they all move back first and the row is re-measured. Below
  // 990px everything stays in the list — the drawer shows every entry.
  var navList = nav.querySelector('.header-navigation__list');
  var moreEntry = nav.querySelector('[data-nav-more]');
  var moreList = nav.querySelector('[data-nav-more-list]');

  function restoreOverflow() {
    while (moreList.firstElementChild) {
      navList.insertBefore(moreList.firstElementChild, moreEntry);
    }
    moreEntry.hidden = true;
  }

  function fitsOnOneRow() {
    return navList.scrollWidth <= navList.clientWidth + 1;
  }

  // Width the row was last laid out at. Height-only changes (a phone's address
  // bar showing/hiding resizes the viewport and the fixed drawer) must NOT
  // re-run this: it closes open menus, which kicked users out of a drilled-in
  // drawer submenu as if they had tapped Back.
  var lastLayoutKey = null;

  function layoutOverflow(force) {
    if (!navList || !moreEntry || !moreList) return;
    var key = window.innerWidth + ':' + navList.clientWidth;
    if (!force && key === lastLayoutKey) return;
    lastLayoutKey = key;

    if (isMobile()) {
      // Drawer lists every entry; only put back anything a desktop pass moved
      if (moreList.firstElementChild) restoreOverflow();
      moreEntry.hidden = true;
      return;
    }

    closeAll();
    restoreOverflow();
    // Hidden row (the expanded search replacing it): nothing to measure
    if (navList.clientWidth === 0 || fitsOnOneRow()) return;

    moreEntry.hidden = false;
    var topEntries = Array.prototype.filter.call(navList.children, function (el) {
      return el !== moreEntry && el.classList.contains('header-navigation__entry');
    });
    // Pop from the end until the row (including "More") fits; keep at least one
    while (!fitsOnOneRow() && topEntries.length > 1) {
      moreList.insertBefore(topEntries.pop(), moreList.firstElementChild);
    }
  }

  var overflowFrame;
  function scheduleOverflow(force) {
    cancelAnimationFrame(overflowFrame);
    overflowFrame = requestAnimationFrame(function () {
      layoutOverflow(force === true);
    });
  }
  // Label widths change once fonts/page finish loading, at the same viewport width
  function forceOverflow() {
    scheduleOverflow(true);
  }

  layoutOverflow(true);
  window.addEventListener('resize', scheduleOverflow);
  window.addEventListener('load', forceOverflow);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(forceOverflow);
  // The nav row reappears after the expanded header search closes
  if (window.ResizeObserver && navList) new ResizeObserver(scheduleOverflow).observe(nav);

  // ---- Mobile drawer ----
  var hamburger = document.querySelector('[data-nav-drawer-toggle]');

  function setDrawerTop() {
    // Drawer opens just BELOW the header — never over it.
    var top;
    var sectionHeader = nav.closest('.section-header');
    if (sectionHeader) {
      // mega_nav: the nav is rendered inside <sticky-header>, so parentElement is
      // the whole header wrapper (top = 0). Measure the header BAR's bottom instead.
      // New header: the logo sits beside the icons row, so the full bar (.header-new)
      // is taller than the .header icons row — measure that when present.
      var headerRow = sectionHeader.querySelector('.header-new') || sectionHeader.querySelector('.header');
      var el = headerRow || sectionHeader;
      top = el.getBoundingClientRect().bottom;
    } else {
      // Standalone nav section — open below whatever sits above it (its own flow top).
      var wrap = nav.parentElement;
      top = wrap ? wrap.getBoundingClientRect().top : 56;
    }
    document.documentElement.style.setProperty('--nav-drawer-top', Math.max(0, Math.round(top)) + 'px');
  }

  // Full-width dropdown panels should span the whole header content box —
  // from the logo's left edge to the cart's right edge — even though the nav
  // list starts after the logo. Expose the two offsets as CSS vars.
  function setFullPanelBounds() {
    var list = nav.querySelector('.header-navigation__list');
    var headerNew = nav.closest('.header-new');
    if (!list || !headerNew) return;
    var logo = headerNew.querySelector('.header-new__logo');
    var cart = headerNew.querySelector('.header__icon--cart');
    var listRect = list.getBoundingClientRect();
    // Hidden list (drawer mode / search replacing the row): keep the last good values
    if (!listRect.width) return;
    // Never past the visible window (12px breathing room each side)
    var viewportRight = document.documentElement.clientWidth - 12;
    var leftAnchor = Math.max(12, logo ? logo.getBoundingClientRect().left : listRect.left);
    var rightAnchor = Math.min(viewportRight, cart ? cart.getBoundingClientRect().right : listRect.right);
    var root = document.documentElement.style;
    root.setProperty('--nav-full-left', Math.max(0, Math.round(listRect.left - leftAnchor)) + 'px');
    root.setProperty('--nav-full-right', Math.max(0, Math.round(rightAnchor - listRect.right)) + 'px');
  }
  setFullPanelBounds();
  window.addEventListener('resize', setFullPanelBounds);
  window.addEventListener('load', setFullPanelBounds);

  // Re-run hug repositioning on resize for whichever panel is open.
  window.addEventListener('resize', function () {
    var openEntry = nav.querySelector('.header-navigation__entry.is-open');
    if (openEntry) positionHugPanel(openEntry);
  });

  function openDrawer() {
    // One panel at a time: collapse an open header search BEFORE measuring.
    // Otherwise the top is taken with the search row still showing, then the
    // search's own outside-click handler shrinks the header and a gap opens
    // between the header and the drawer.
    var openSearch = document.querySelector('.header-search-inline.is-expanded [data-header-search-close]');
    if (openSearch) openSearch.click();
    setDrawerTop();
    document.body.classList.add('nav-drawer-open');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
  }

  window.addEventListener('resize', function () {
    if (document.body.classList.contains('nav-drawer-open')) setDrawerTop();
  });
  function closeDrawer() {
    document.body.classList.remove('nav-drawer-open');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
    closeAll();
  }

  if (hamburger) {
    hamburger.addEventListener('click', function () {
      if (document.body.classList.contains('nav-drawer-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  }

  Array.prototype.forEach.call(
    document.querySelectorAll('[data-nav-drawer-close]'),
    function (el) {
      el.addEventListener('click', closeDrawer);
    }
  );

  // Back bar — return from a drilled submenu to the top list
  Array.prototype.forEach.call(
    document.querySelectorAll('[data-nav-back]'),
    function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeAll();
      });
    }
  );

  // Close on Escape (drawer + dropdowns)
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAll();
      closeDrawer();
    }
  });
})();
